import { NetworkError } from "common/api-errors/network.error";
import { PrOSValidationError, ValidationError } from "common/validationErrors";
import { useFeedbackStore } from "core/stores";
import { ReactNode } from "react";

import { IconButton } from "@bps/fluent-ui";

import { ConcurrencyError } from "./concurrency.error";
import { ConflictError } from "./conflict.error";

export function handleError(error: any, dataType: string): void {
  if (error instanceof ConcurrencyError || error instanceof ConflictError) {
    useFeedbackStore.getState().error(getConcurrencyError(dataType), 6000);
    return;
  }

  if (error instanceof NetworkError) {
    useFeedbackStore.getState().error(error.message);
    return;
  }

  if (error instanceof ValidationError) {
    useFeedbackStore.getState().error(error.message);
    return;
  }

  if (error instanceof PrOSValidationError) {
    useFeedbackStore.getState().error(error.message);
    return;
  }

  useFeedbackStore
    .getState()
    .error(`An error occurred updating the ${dataType}.`);
}

export function getConcurrencyError(dataType: string): ReactNode {
  return (
    <p>
      Update failed. Another user has made changes to this {dataType}.<br />
      Refresh to see the latest version of this record.
      <IconButton
        iconProps={{ iconName: "Refresh" }}
        onClick={() => window.location.reload()}
      />
    </p>
  );
}
